import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-7ca57bf1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "spv" }
const _hoisted_2 = { class: "spv__elm" }
const _hoisted_3 = { class: "spv__elm-backward" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spv__elm-backward-label" }, "Настройки профиля", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconArrowLeft = _resolveComponent("IconArrowLeft")!
  const _component_SettingProfile = _resolveComponent("SettingProfile")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (!_ctx.device.isMobile)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "spv__elm-backward-link",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onClickRedirect('instances')))
            }, [
              _createVNode(_component_IconArrowLeft, { color: "rgb(49, 49, 50)" })
            ]))
          : _createCommentVNode("", true),
        _hoisted_4
      ]),
      _createVNode(_component_SettingProfile)
    ])
  ]))
}